import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'gatsby'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import Blog from '../../../assets/images/social/blogger.svg'
import Facebook from '../../../assets/images/social/icon_facebook.svg'
import Instagram from '../../../assets/images/social/instagram.svg'
import LinkedIn from '../../../assets/images/social/linkedin.svg'
import X from '../../../assets/images/social/x.svg'
import YouTube from '../../../assets/images/social/youtube.svg'
import assertUnreachable from '../../../utils/assertUnreachable'
import NewsLetter from '../../NewsLetter/NewsLetter'
import styles from './column.module.scss'
import { FooterItem } from '../../../constants/footer'

interface LinkMenuProps {
  name: string
  url: string
  external: boolean
  rel?: 'nofollow'
  target?: string
}
const LinkMenu = ({
  name,
  url,
  external = false,
  rel,
  target,
}: LinkMenuProps) =>
  external ? (
    <a className={styles.submenu_item} href={url} rel={rel} target={target}>
      <FormattedMessage id={name} />
    </a>
  ) : (
    <Link className={styles.submenu_item} to={url}>
      <FormattedMessage id={name} />
    </Link>
  )

const TitleColumn = ({ name, onClick, showColumn }) => (
  <React.Fragment>
    <div className={styles.title_mobile} onClick={() => onClick(name)}>
      <h4>
        <FormattedMessage id={name} />
      </h4>
      {showColumn === name ? (
        <FontAwesomeIcon icon={faChevronUp} />
      ) : (
        <FontAwesomeIcon icon={faChevronDown} />
      )}
    </div>
    <div className={styles.title_desktop}>
      <h4>
        <FormattedMessage id={name} />
      </h4>
    </div>
  </React.Fragment>
)

const NewsletterColumn = ({ showColumn, onClick, column }) => (
  <div className={`${styles.container} ${styles.newsletter}`}>
    <TitleColumn name={column.name} showColumn={showColumn} onClick={onClick} />
    <div
      className={
        showColumn === column.name
          ? styles.links_block
          : styles.links_block_hidden
      }>
      <NewsLetter />
    </div>
  </div>
)

const icons = {
  blog: <Blog />,
  facebook: <Facebook />,
  instagram: <Instagram />,
  x: <X />,
  linkedin: <LinkedIn />,
  youtube: <YouTube />,
}

const StandardColumn = ({ showColumn, onClick, column }: Props) => (
  <div className={styles.container}>
    <TitleColumn name={column.name} showColumn={showColumn} onClick={onClick} />
    <div
      className={
        showColumn === column.name
          ? styles.links_block
          : styles.links_block_hidden
      }>
      {column.subtitles.map((subtitle) => (
        <div
          key={subtitle.name}
          className={subtitle.icon && styles.link_and_logo}>
          {subtitle.icon && icons[subtitle.icon]}
          <LinkMenu
            key={subtitle.name}
            name={subtitle.name}
            url={subtitle.url}
            external={subtitle.external}
            rel={subtitle.rel}
            target={subtitle.target}
          />
        </div>
      ))}
    </div>
  </div>
)

interface Props {
  column: FooterItem
  showColumn: string
  onClick: (newShowColumn: string) => void
}
export default function Column({ showColumn, onClick, column }: Props) {
  switch (column.component) {
    case 'standard':
      return (
        <StandardColumn
          showColumn={showColumn}
          onClick={onClick}
          column={column}
        />
      )

    case 'newsletter':
      return (
        <NewsletterColumn
          showColumn={showColumn}
          onClick={onClick}
          column={column}
        />
      )
  }
  return assertUnreachable(column.component)
}
